if (!customElements.get('product-description-toggle')) {
  customElements.define(
    'product-description-toggle',
    class ProductDescriptionToggle extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('[data-description-content]');
        this.button = this.querySelector('.custom-product-description__toggle');
        if (!this.content || !this.button) return;

        this.button.addEventListener('click', () => {
          const expanded = this.classList.toggle('is-expanded');
          this.button.setAttribute('aria-expanded', String(expanded));
          this.querySelector('[data-read-more]').hidden = expanded;
          this.querySelector('[data-read-less]').hidden = !expanded;
        });

        this.measure = () => {
          if (this.classList.contains('is-expanded')) return;
          const limit = parseFloat(getComputedStyle(this).getPropertyValue('--description-collapsed-height'));
          const needsToggle = this.content.scrollHeight > limit + 2;
          this.classList.toggle('is-collapsible', needsToggle);
          this.button.hidden = !needsToggle;
        };

        requestAnimationFrame(this.measure);
        this.resizeObserver = new ResizeObserver(this.measure);
        this.resizeObserver.observe(this.content);
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }
    }
  );
}
